import React from 'react';
import { useSelector } from 'react-redux';
import '../styles.css';
import { YELLOW, GREEN, CYAN } from '../../HOME/const';
import * as f from '../logic';

const Scoreboard = () => {
  const cm = useSelector(state => state.cm);
  const { stats, size, secs, bonus } = cm;
  const cleared = cm.cleared || 0;
  let { aveSecs, bestSecs, aveScore, bestScore } = stats;
  const plays = stats.plays || 0;

  if (size) {
    aveScore = f.scoreFromSecs(aveSecs, size);

    if (aveScore === 1000) {
      aveScore = 0;
    }

    bestScore = f.scoreFromSecs(bestSecs, size);

    if (bestScore === 1000) {
      bestScore = 0;
    }
  }

  const grade = size ? f.getGrade(aveScore, plays) : bestScore || 0;

  let score;

  if (size) {
    score = f.scoreFromSecs(secs, size);
    score = Math.max(10, score);
  } else {
    score = cleared + (bonus || 0);
  }

  return (
    <div className="tt-scoreboard">
      <span style={{ gridArea: `${size ? '1/1' : '1/1/1/span 2'}`, color: YELLOW, fontWeight: 'bold' }}>{plays}</span>
      <span style={{ gridArea: `${size ? '2/1' : '2/1/2/span 2'}`, marginTop: '-1px' }}>plays</span>
      <span style={{ gridArea: `${size ? '1/2' : '1/2/1/span 2'}`, color: GREEN, fontWeight: 'bold' }}>{aveScore}</span>
      <span style={{ gridArea: `${size ? '2/2' : '2/2/2/span 2'}`, marginTop: '-1px' }}>ave. score</span>
      {size ? (
        <>
          <span style={{ gridArea: '1/3', color: GREEN, fontWeight: 'bold' }}>{bestScore}</span>
          <span style={{ gridArea: '2/3', marginTop: '-1px' }}>best score</span>
        </>
      ) : null}
      <span className="nm-quartz" style={{ gridArea: '3/1', color: CYAN }}>
        {size ? size - cleared : cleared}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/1' }}>
        {size ? 'to go' : 'cleared'}
      </span>
      <span className="nm-quartz" style={{ gridArea: '3/2', color: YELLOW }}>
        {grade}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/2' }}>
        {size ? 'grade' : 'best score'}
      </span>
      <span className="nm-quartz" style={{ gridArea: '3/3', color: GREEN }}>
        {score}
      </span>
      <span className="tt-score-label" style={{ gridArea: '4/3' }}>
        score
      </span>
    </div>
  );
};

export default Scoreboard;
